import { createContext, useState, useEffect, useContext } from "react";

interface AuthContextType {
  auth: Auth;
  setAuth: React.Dispatch<React.SetStateAction<Auth>>;
  persist: boolean;
  setPersist: React.Dispatch<React.SetStateAction<boolean>>;
}

const AuthContext = createContext<AuthContextType | null>(null);

let globalSetAuth: React.Dispatch<React.SetStateAction<Auth>> | null = null;
export const getGlobalSetAuth = () => globalSetAuth;

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [auth, setAuth] = useState<Auth>(() => {
    const stored = localStorage.getItem("auth");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        return parsed;
      } catch {
        // ignore parsing errors
      }
    }
    return {
      data: null,
      status: "unauthenticated",
    }
  });

  // Load persist flag from localStorage or default to false
  const [persist, setPersist] = useState(() => {
    const stored = localStorage.getItem("persist");
    return stored === "true";
  });

  // Store persist value in localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("persist", persist.toString());
  }, [persist]);

  // Optional: Persist auth state too
  useEffect(() => {
    if (persist) {
      const storedAuth = localStorage.getItem("auth");
      if (storedAuth) {
        try {
          const parsed = JSON.parse(storedAuth);
          setAuth(parsed);
        } catch {
          // ignore parsing errors
        }
      }
    }
  }, [persist]);

  useEffect(() => {
    if (persist && auth.status === "authenticated") {
      localStorage.setItem("auth", JSON.stringify(auth));
    } else {
      localStorage.removeItem("auth");
    }
  }, [auth, persist]);

  useEffect(() => {
    globalSetAuth = setAuth;
  }, [setAuth]);

  console.log(persist)

  return (
    <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export { AuthProvider, useAuth };
